/**
 * 公共弹框
 */
import React, {Component} from "react";
import {Modal} from "antd";
import BaseComponent from "../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from "../../utils";

export default class CmModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            windowOnKeyup: null
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // 添加【回车】响应确认功能
        const {windowOnKeyup} = this.state;
        if (this.props.visible !== prevProps.visible) {
            if (this.props.visible) {
                // 如果绑定有方法 保存方法 并且
                this.setState({
                    windowOnKeyup: window.onkeydown
                });
                // window.onkeydown = e => {
                //     if (e.keyCode === 13) {
                //         this.props.handleOk();
                //     }
                // };
            } else {
                window.onkeydown = windowOnKeyup;
                this.setState({
                    windowOnKeyup: null
                });
            }
        }
    }

    componentDidMount() {
        // if (this.props.visible) {
        //     window.onkeydown = e => {
        //         if (e.keyCode === 13) {
        //             this.props.handleOk();
        //         }
        //     };
        // }
    }

    render() {
        const {
            visible, // 控制显示隐藏
            title, // 标题
            width = 800, // 宽度 默认800
            handleCancel, // 取消回调
            handleOk, // 确认的回调
            cancelText = "取消",
            okText = "确认",
            footer,
            centered = true,
            destroyOnClose,
            isDeleteIds
        } = this.props;

        return <Modal
            title={title}
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            cancelText={cancelText}
            okText={okText}
            width={width}
            footer={footer}
            maskClosable={false}
            centered={centered}
            destroyOnClose={destroyOnClose}
            bodyStyle={{padding: isDeleteIds === 'isDeleteIds' ? '15px 24px' : '10px 24px'}}
        >
            <Scrollbars className={this.props.isMenuTree?"cm-scrollbars":""} autoHeight={true} autoHeightMax="650px" autoHide onScroll={() => {
                this.props.onScrollSelect && this.props.onScrollSelect();
            }}>
                {this.props.children}
            </Scrollbars>
        </Modal>;
    }
}

